import React, { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  Avatar,
  Box,
  ButtonBase,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { signout } from 'src/actions/accountActions';

function Account() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  const navigate = useNavigate();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSignout = async () => {
    try {
      handleClose();
      await dispatch(signout());
      navigate('/');
    } catch (error) {
      enqueueSnackbar('Unable to signout', {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <AccountCircleIcon fontSize="large" color="inherit" />
        {isSmUp && (
          <Typography variant="h6" color="inherit" sx={{ ml: 1 }}>
            {account.user?.name}
          </Typography>
        )}
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        anchorEl={ref.current}
        open={isOpen}
        PaperProps={{
          sx: { width: 200 }
        }}
      >
        <MenuItem component={RouterLink} to="/app/account">
          Account
        </MenuItem>
        <MenuItem onClick={handleSignout}>
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
}

export default Account;
